import type { CommunityFeedSurveyDto, SurveyDetailsV2Dto, SurveyDto } from "@/api/types";

export const getIsSurveySharable = (survey: SurveyDetailsV2Dto | CommunityFeedSurveyDto | SurveyDto): boolean => {
  return survey.status === "running";
};
